var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"flex-row w-100"},[_c('el-card',{staticClass:"flex-column mt-5 text-center"},[_vm._v(" procesando respuesta ... ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }